import { SELECTED_RETAILER } from "./type"
const retailerId= sessionStorage.getItem('rid')
const retailerName = sessionStorage.getItem('rname')
const initialState = {
    id: retailerId ? retailerId :  null,
    name: retailerName ? retailerName : ''

}
const selectedRetailerReducer = (state = initialState, action) => {
    switch (action.type) {
        case SELECTED_RETAILER:
            return {
                ...state,
                id:action.payload.id,
                name:action.payload.name
            }
       

        default:
            return state
    }
}

export default selectedRetailerReducer